import React from 'react';
import { Link } from 'react-router-dom';
import { locations } from '../data/locations';

const Timeline: React.FC = () => {
  return (
    <div style={{ position: 'relative', padding: '8px 12px' }}>
      <div
        style={{
          position: 'absolute',
          left: '31px',
          top: '8px',
          bottom: '8px',
          width: '2px',
          background: 'rgba(15,23,42,0.12)',
        }}
      />

      {locations.map((loc, i) => (
        <Link
          key={loc.slug}
          to={`/location/${loc.slug}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '14px 8px 14px 14px',
              borderRadius: '12px',
              borderBottom:
                i < locations.length - 1
                  ? '1px solid rgba(15,23,42,0.08)'
                  : 'none',
              cursor: 'pointer',
              transition: 'background 0.15s ease',
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = 'rgba(15,23,42,0.04)')
            }
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #6366f1, #a855f7)',
                flexShrink: 0,
                zIndex: 1,
                boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.9)',
              }}
            />

            <img
              src={loc.image}
              alt={loc.name}
              style={{
                width: '64px',
                height: '64px',
                objectFit: 'cover',
                borderRadius: '12px',
                boxShadow: '0 4px 14px rgba(0,0,0,0.35)',
                flexShrink: 0,
              }}
            />

            <div>
              <div style={{ fontWeight: 600, fontSize: '16px', color: '#171616' }}>
                {loc.name}
              </div>
              <div style={{ fontSize: '13px', color: '#64748b' }}>
                {loc.country} · {loc.dateRange}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Timeline;
